module.exports = __webpack_public_path__ + "static/media/iconGlasses.338058bb.png";